module.exports = __webpack_public_path__ + "static/media/sheild.d3cb8645.png";